import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import _, { filter } from 'lodash';

const Rapid7InsightVMMappingForm = forwardRef(function Rapid7InsightVMMappingForm({disableProjectFields = false, ...props}, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { tagIds, tagNames } = props.record;

      const tagIdArray = _.isEmpty(tagIds) ? [] :tagIds.split(',');
      const tagNameArray = _.isEmpty(tagNames) ? [] :tagNames.split(',');
      if (tagIdArray.length === 0 || tagNameArray.length === 0) {
        return [];
      }
      return tagIdArray.map((id, index) => ({id, name: tagNameArray[index]}))
    }
    return [];
  });

  const isOnPrem = props.loginConfig?.username !== null;

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching projects');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { tagIds, tagNames} = config;
    return ({
        tagIds: tagIds ? tagIds.split(',') : [],
        tagNames: tagNames ? tagNames.split(',') : []
    });
  }, []);

  const getExtraFieldsData = (config) => {
    const { tagIds } = config;

    if (isOnPrem && (!tagIds || tagIds.length === 0)) {
      return {
        tagIds: null,
        tagNames: null
      };
    }
    
    const tagNames = filter(projects, (obj) => tagIds.includes(obj.id)).map(tag => tag.name);

    return ({
      tagIds:tagIds.join(),
      tagNames: tagNames.join()
    });
  }

  const extraFields = useMemo(() => ([
    {
      name: 'tagIds',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      label: 'Tag Names',
      disabled: disableProjectFields,
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: (isOnPrem) ? false : true,
      props: {
        autoFocus: !disableProjectFields,
        placeholder: isOnPrem ? 'Leave blank to select all' : 'Tag Names'
      }
    }
  ]), [disableProjectFields, projects, isOnPrem]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default Rapid7InsightVMMappingForm;
